import Metrics from '~/types/Metrics';
import { ActionKeys } from './constants';

export function fetchMetrics(startDate: Date, endDate: Date) {
  return <const>{
    type: ActionKeys.ANALYTICS_FETCH_METRICS,
    payload: {
      startDate,
      endDate,
    },
  };
}

export function fetchMetricsSuccess(metrics: Metrics) {
  return <const>{
    type: ActionKeys.ANALYTICS_FETCH_METRICS_SUCCESS,
    payload: {
      metrics,
    },
  };
}

export function fetchMetricsError() {
  return <const>{
    type: ActionKeys.ANALYTICS_FETCH_METRICS_ERROR,
  };
}

export type AnalyticsActions =
  | ReturnType<typeof fetchMetrics>
  | ReturnType<typeof fetchMetricsSuccess>
  | ReturnType<typeof fetchMetricsError>;
